var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 4,
    viewBox: "0 0 6 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33268 0.962983C5.33268 1.04323 5.30382 1.11267 5.24609 1.17132L3.20443 3.24539C3.1467 3.30403 3.07834 3.33335 2.99935 3.33335C2.92036 3.33335 2.852 3.30403 2.79427 3.24539L0.752604 1.17132C0.694878 1.11267 0.666016 1.04323 0.666016 0.962983C0.666016 0.882736 0.694878 0.813292 0.752604 0.75465C0.81033 0.696008 0.878689 0.666687 0.957682 0.666687H5.04102C5.12001 0.666687 5.18837 0.696008 5.24609 0.75465C5.30382 0.813292 5.33268 0.882736 5.33268 0.962983Z",
    fill: "#8C2D9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterDropdownIcon);
export default __webpack_public_path__ + "static/media/filter_dropdown_icon.7fefc70505bb96c691e077ad9632e44b.svg";
export { ForwardRef as ReactComponent };